import { makeAutoObservable } from 'mobx'
import { nanoid } from 'nanoid'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { logger } from 'shared/lib'
import { DeviceItemsEnum } from 'entities/DeviceSettings'
import { RecordStore } from 'widgets/Record'
import { RecordVideoContent } from 'widgets/RecordVideo/ui/RecordVideoContent'

const DEFAULT_RECORD_MIME_TYPE = 'video/webm'
const RECORD_MIME_TYPE = 'video/webm'

export class RecordVideoStore {
  private _recordStore = new RecordStore({
    deviceItems: [DeviceItemsEnum.videoInput, DeviceItemsEnum.audioInput],
    DEFAULT_RECORD_MIME_TYPE,
    RECORD_MIME_TYPE,
    permissions: ['camera', 'microphone'],
    withDelay: true,
  })
  private _modalId = ''

  constructor() {
    makeAutoObservable(this)
  }

  get recordStore() {
    return this._recordStore
  }

  setOpenModal = async (onAddVideoRecord: (file: File) => void) => {
    try {
      const handleClose = () => {
        modalStore.removeModal(this._modalId)
      }
      const onAllow = () => {
        const id = nanoid()
        this._modalId = id
        modalStore.addModal({
          id,
          title: 'Record video',
          pureContent: true,
          ModalContent: RecordVideoContent,
          ModalContentProps: {
            store: this,
          },
          width: 502,
          onClose: this.onCloseModal,
        })
      }
      await this._recordStore.init({
        onAddRecord: onAddVideoRecord,
        onAllow,
        handleClose,
        rejectInfo: {
          title: 'Camera and microphone access required',
          desc: 'To enable recording, please allow Salesmsg to access your camera and microphone',
        },
      })
    } catch (e) {
      logger.error(e)
    }
  }

  onCloseModal = () => {
    this._recordStore.onClose()
  }
}
